/* Auto-generated from about-portal/shared/publicPlanPricing.mjs. Do not edit manually. */
const deepFreeze = (value) => {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;
  Object.values(value).forEach((entry) => deepFreeze(entry));
  return Object.freeze(value);
};

export const PUBLIC_PLAN_PRICING = deepFreeze({
  "free": {
    "brl": {
      "currency": "BRL",
      "amountMinor": 0,
      "priceDisplay": "R$ 0,00"
    }
  },
  "basic": {
    "brl": {
      "currency": "BRL",
      "amountMinor": 2490,
      "priceDisplay": "R$ 24,90",
      "compareAtAmountMinor": 3490,
      "compareAtPriceDisplay": "R$ 34,90"
    },
    "usd": {
      "currency": "USD",
      "amountMinor": 999,
      "priceDisplay": "US$ 9,99",
      "compareAtAmountMinor": 1690,
      "compareAtPriceDisplay": "US$ 16,90"
    }
  },
  "premium": {
    "brl": {
      "currency": "BRL",
      "amountMinor": 4990,
      "priceDisplay": "R$ 49,90",
      "compareAtAmountMinor": 6990,
      "compareAtPriceDisplay": "R$ 69,90"
    },
    "usd": {
      "currency": "USD",
      "amountMinor": 2290,
      "priceDisplay": "US$ 22,90",
      "compareAtAmountMinor": 2990,
      "compareAtPriceDisplay": "US$ 29,90"
    }
  }
});

export const PLAN_PRICE_COPY = deepFreeze({
  "pt": {
    "basic": {
      "brl": "Brasil: de R$ 34,90 por R$ 24,90/mês (preço promocional público atual)",
      "usd": "Exterior: de US$ 16,90 por US$ 9,99/mês (preço promocional público atual)"
    },
    "premium": {
      "brl": "Brasil: de R$ 69,90 por R$ 49,90/mês (preço promocional público atual)",
      "usd": "Exterior: de US$ 29,90 por US$ 22,90/mês (preço promocional público atual)"
    }
  },
  "en": {
    "basic": {
      "brl": "Brazil: from R$ 34,90 to R$ 24,90/month (current public promotional price)",
      "usd": "International: from US$ 16,90 to US$ 9,99/month (current public promotional price)"
    },
    "premium": {
      "brl": "Brazil: from R$ 69,90 to R$ 49,90/month (current public promotional price)",
      "usd": "International: from US$ 29,90 to US$ 22,90/month (current public promotional price)"
    }
  },
  "es": {
    "basic": {
      "brl": "Brasil: de R$ 34,90 a R$ 24,90/mes (precio promocional público actual)",
      "usd": "Exterior: de US$ 16,90 a US$ 9,99/mes (precio promocional público actual)"
    },
    "premium": {
      "brl": "Brasil: de R$ 69,90 a R$ 49,90/mes (precio promocional público actual)",
      "usd": "Exterior: de US$ 29,90 a US$ 22,90/mes (precio promocional público actual)"
    }
  }
});
